import { Navigate, type RouteObject } from 'react-router';
import { recordTabRoutes } from '../../shared/components/record-tab-routes';
import { OWNER_TABS } from './features/owners/owners.paths';
import { OwnerDetailPage } from './features/owners/pages/OwnerDetailPage';
import { RedirectToUnit } from './features/units/pages/RedirectToUnit';
import { UnitPage } from './features/units/pages/UnitPage';
import { UNIT_TABS } from './features/units/units.paths';
import { FLEET_TABS, fleetTabPath } from './fleet.paths';
import { FleetPage } from './pages/FleetPage';
import { RedirectToFleetRecord } from './pages/RedirectToFleetRecord';

/**
 * Fleet's tabs and the units and owners under them; records live under their tab so the sidebar keeps Fleet highlighted. A unit
 * is addressed by registration (gitaumoses4/chukua#390); the trucks' and trailers' own addresses by id now open their unit.
 */
export const FLEET_ROUTES: RouteObject[] = [
  { path: 'fleet', element: <Navigate to={fleetTabPath(FLEET_TABS[0])} replace /> },
  ...FLEET_TABS.map((tab) => ({ path: `fleet/${tab}`, element: <FleetPage tab={tab} /> })),
  ...recordTabRoutes('fleet/units/:registration', UNIT_TABS, (tab) => <UnitPage tab={tab} />),
  ...recordTabRoutes('fleet/owners/:id', OWNER_TABS, (tab) => <OwnerDetailPage tab={tab} />),
  // The tabs and record addresses from before trucks and trailers became units, kept as redirects.
  { path: 'fleet/rigs', element: <Navigate to={fleetTabPath('units')} replace /> },
  { path: 'fleet/trucks', element: <Navigate to={fleetTabPath('units')} replace /> },
  { path: 'fleet/trailers', element: <Navigate to={`${fleetTabPath('units')}?kind=trailer_only`} replace /> },
  { path: 'fleet/trucks/:id/:tab?', element: <RedirectToUnit vehicleKind="truck" /> },
  { path: 'fleet/trailers/:id/:tab?', element: <RedirectToUnit vehicleKind="trailer" /> },
  { path: 'fleet/:id', element: <RedirectToUnit vehicleKind="truck" /> },
  { path: 'trailers/:id', element: <RedirectToUnit vehicleKind="trailer" /> },
  { path: 'owners/:id', element: <RedirectToFleetRecord tab="owners" /> },
];
